import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n ({
    locale: 'ar',
    fallbackLocale: 'ar',
    silentTranslationWarn: true,
    messages: {

        /* english */
        en: {
            //
            auth: {
                email_address: 'Email Address',
                mobile: 'Mobile',
                password: 'Password',
                remember_me: 'Remember Me',
                forget_password: 'Forget Password?',
                login: 'Login',
                return_login: 'Return to login?',
                submit: 'Submit',
                key_code: 'Code',
                new_password: 'New Password',
                con_new_password: 'Confirm New Password',
            },

            nav: {
                dashboard: 'Dashboard',
                companies: 'Companies',
                contracttypes: 'Contract Types',
                contracts: 'Contracts',
                bills: 'Bills',
                financialbondtype : 'Financialbond Types',
                financialbonds : 'Financialbonds',
                //
                roles: 'Roles',
                users: 'Users',
                //
                employees: 'Employees',
                autoequipment: 'Auto Equipment',
                notifications: 'Notifications',
                licenses: 'licenses',
                companylicenses: 'Company Licenses',
                vacations: 'Vacations',
                absences: 'Absences',
                rewards: 'Rewards',
                settings: 'Settings'
            },

            app: {
                welcome: 'Welcome',
                copyright: 'Copyright © ',
                gatetechs: 'Gate Techs',
                choose_bond_types: 'Choose Bond Type',
                choose_companies: 'Choose Company',
                choose_contracts: 'Choose Contract',
                choose_contracttypes: 'Choose Contract Type',
                choose_employee: 'Choose Employee',
                choose_license: 'Choose License',
                more_info:  'More Info',
                bill_number: 'Bill Number',
                amount_duo: 'Amount Duo',
                number_of_payments: 'Number of payments',

                nationalities: 'Nationalities',

                choose_notification_period: 'Choose Notification Period',
                email_from : 'Email From',
                email_to: 'Email To',

                bond_types: 'Financialbond Types',
                companies: 'Companies',
                contracts: 'Contracts',
                check_number: 'Check Number',
                bond_number: 'Financialbond Number',
                day: 'Day',

                show_attachment : 'Show Attachment',
                add_new        : 'Add New',
                contact        : 'Contract',
                all            : 'All',
                hello          : 'Hello ',
                profile        : 'Profile',
                logout         : 'Logout',
                purple         : 'Purple',
                dark           : 'Dark',
                update         : 'Update',
                create         : 'Create',
                show           : 'Show',
                back           : 'Back',
                cancel         : 'Cancel',
                active         : 'Active',
                approved       : 'Approved',
                unapproved     : 'UnApproved',
                seen           : 'Seen',
                unseen         : 'UnSeen',
                inactive       : 'InActive',
                from           : 'From',
                to             : 'To',
                excel          : 'Export to XLS',
                csv            : 'Export to CSV',
                print          : 'Print',
                upload_excel   : 'Upload XLSX',
                edit           : 'Edit',
                analytics      : 'Analytics',
                addNew         : 'Add New',
                dashboard      : 'Dashboard',
                search         : 'Search...',
                arabic         : 'Arabic',
                english        : 'English',

                all_rows       : 'All',
                showInHeader   : 'Show in header',
                showInFooter   : 'Show in footer',
                showInSupport  : 'Show in Support',

                start_cdate     : 'Start Date',
                end_cdate       : 'End Date',
                start_date     : 'Start Date',
                end_date       : 'End Date',
                contract_start_date     : 'Contract Start Date',
                contract_end_date       : 'Contract End Date',
                notebookExpireDate : 'Notebook expire date',
                invoice_date   : 'Invoice Date',
                bond_date      : 'Financialbond Date',
                date           : 'Date',
                actions        : 'Actions',
                status         : 'Status',
                sort           : 'Sort',
                rate           : 'Rate',
                star           : 'Star',
                stars          : 'Stars',
                upload         : 'Upload',
                change_upload  : 'Edit Upload',
                
                upload_attachment : 'Upload File',
                change_upload_attachment  :  'Edit Upload File',

                employeecategories: 'Employee Category',
                jobtitles: 'Job Title',

                social         : 'Social Media',
                facebook       : 'Facebook',
                twitter        : 'Twitter',
                linkedin       : 'Linkedin',

                export         : 'Export',
                bulkActions    : 'Bulk Actions',

                // msgs
                success_title  : 'Great,',
                success_msg    : 'Request Successfully.',
                warning_title  : 'Wo wo wo',
                warning_msg    : '',
                error_title    : 'Warning',
                error_msg      : 'Something went wrong',
                no_data        : 'No data found.',
                invalid_credentials : 'Invalid credentails',

                month          : 'Month',
                year           : 'Year',

                january        : 'January',
                february       : 'February',
                march          : 'March',
                april          : 'April',
                may            : 'May',
                june           : 'June',
                july           : 'July',
                august         : 'August',
                september      : 'September',
                october        : 'October',
                november       : 'November',
                december       : 'December',

                sunday         : 'Sunday',
                monday         : 'Monday',
                tuesday        : 'Tuesday',
                wedensday      : 'Wedensday',
                thursday       : 'Thursday',
                friday         : 'Friday',
                saturaday      : 'Saturaday',

                absent         : 'Absent',
                reward         : 'Reward',
                vacation       : 'Vacation'

            },

            view: {
                attachemnts: 'Attachments',
                bill_attachment : 'Bill Attachments',
                
                company_logo: 'Company Logo',
                company_info: 'Company Info',
                company_name: 'Company Name',
                company_body: 'Company Description',
                company_address: 'Company Address',
                company_mobile: 'Company Mobile',
                company_email: 'Email Address',
                company_website: 'Website',
                company_contact_person: 'Contact Person',

                contracttype_name: 'Contract Type',
                contracttype_info: 'Contract Type Info',
                contracttype_body: 'Contract Type Description',

                bill_image: 'Bill Image',
                bill_info: 'Bill Info',
                bill_name: 'Bill Title',
                bill_body: 'Bill Description',

                contract_name: 'Contract Title',
                contract_info: 'Contract Info',
                contract_body: 'Contract Description',

                financialbondtype_name: 'Financialbond Type Title',
                financialbondtype_info: 'Financialbond Type Info',
                financialbondtype_body: 'Financialbond Type Description',

                financialbond_info: 'Financialbond Info',
                financialbond_name: 'Financialbond Title',
                financialbond_body: 'Financialbond Description',
                financialbond_amount_in_letters: 'Financialbond amount in letters',
                bank_name: 'Bank Name',

                reward_info: 'Reward Info',
                reward_name: 'Reward Title',
                reward_body: 'Reward Description',

                absence_info: 'Absence Info',
                absence_name: 'Absence Title',
                absence_body: 'Absence Description',

                vacation_info: 'Vacation Info',
                vacation_name: 'Vacation Title',
                vacation_body: 'Vacation Description',

                companylicense_info: 'Company Licenses Info',
                companylicense_name: 'Company Licenses Name',
                companylicense_body: 'Company Licenses Description',

                license_startDate: 'License Start Date',
                license_endDate: 'Licenses End Date',
                license_no: 'Licenses No.',

                license_info: 'Licenses Info',
                license_name: 'Licenses Name',
                license_body: 'Licenses Description',

                equipment_info: 'Autoequipment Info',
                equipment_name: 'Autoequipment Name',
                equipment_body: 'Autoequipment Description',
                equipment_type: 'Autoequipment Type',
                equipment_model: 'Autoequipment Model',
                equipment_plateNo: 'Plate No.',
                equipment_ownerName: 'Owner Name',
                equipment_receiverName: 'Receiver Name',

                employee_info: 'Employee Info',
                employee_name: 'Employee Name',
                employee_image: 'Employee Image',
                employee_jobTitle : 'Job Title',
                employee_nationality: 'Nationality',
                employee_civilNo: 'Civil No.',
                employee_passportNo: 'Passport No.',
                employee_passportExpireDate: 'Passport Expire Date',
                employee_category: 'Employee Category',
                employee_fullName: 'Full Name',
                employee_hiringDate: 'Hiring Date',
                employee_residenceExpireDte: 'Residence Expire Date',
                employee_startWorkDate: 'Start work date',
                employee_endWorkDate: 'End work Date',
                employee_phone: 'Mobile',
                employee_salary: 'Salary',
                employee_salaryPerDay: 'Salary Per day',
                employee_bankName: 'Bank Name',
                employee_bankIBAN: 'Bank ( IBAN )',
                employee_bankBranchName: 'Branch Name',
                employee_bankCreditNo: 'Credit Card No.',
                employee_bankPassword: 'CVV',
                employee_licenseNo: 'License No.',
                employee_licenseExpireDate: 'License Expire Date',

                setting_info: 'Setting Info',


                username: 'Name',
                email: 'Email Address',
                image: 'Image',

                permissions: 'Permissions',
                role_info: 'Role Info',

                role_name: 'Role Name',
                password: 'Password',
                users_no: 'Users No.',
                contracts_no: 'Contracts No.',
                name: 'Name',
                title: 'Title',
                body: 'Description',
                addMore: 'Add More',
                noPermissionGranted: 'No permission granted',
            },

            role: {
                add            : 'Add',
                edit           : 'Edit',
                delete         : 'Delete',
                view           : 'View',
            },

            chart: {
                total_companies        : 'Total Companies',
                total_contracts        : 'Total Contracts',
                total_contract_types   : 'Total Contract Types',
                total_bills            : 'Total Bills',

                total_bond_types       : 'Total Financialbond Types',
                total_financial_bonds  : 'Total Financial Bonds',

                total_auto_equipment   : 'Total Auto Equipment', 
                total_licenses         : 'Total Licenses', 
                total_company_licenses : 'Total Company Licenses',
                total_employees        : 'Total Employees',

                total_notifications    : 'Total Notifications',
                total_admins           : 'Total Admins',

                total_roles            : 'Total Roles',
                total_absences         : 'Total Absences',
                total_vacations        : 'Total Vacations',
                total_rewards          : 'Total Rewards',

                contracts_chart        : 'Contracts Chart',

                yearly                 : 'Yearly',
                quarter                : 'Quarter',
                weekly                 : 'Weekly',
                monthly                : 'Monthly',

            },
            //
        },



        /* Arabic */
        ar: {
            //
            auth: {
                email_address: 'البريد الإلكتروني',
                mobile: 'رقم الجوال',
                password: 'كلمة المرور',
                remember_me: 'تذكرني',
                forget_password: 'نسيت كلمة المرور ؟',
                login: 'تسجيل دخول',
                return_login: 'رجوع لتسجيل الدخول؟',
                submit: 'إرسالة',
                key_code: 'الكود',
                new_password: 'كلمة المرور الجديدة',
                con_new_password: 'تأكيد كلمة المرور',
            },

            nav: {
                dashboard: 'لوحة التحكم',
                companies: 'الشركات',
                contracttypes: 'أنواع العقود',
                contracts: 'العقود',
                bills: 'الفواتير',
                financialbondtype : 'انواع السندات المالية',
                financialbonds : 'السندات المالية',
                //
                roles: 'الصلاحيات',
                users: 'مستخدمين النظام',
                //
                employees: 'إدارة حسابات الموظفين',
                autoequipment: 'إدارة المعدات والسيارات',
                notifications: 'التنبيهات',
                licenses: 'الرخص',
                companylicenses: 'إدارة رخص الشركات',
                vacations: 'الأجازات',
                absences: 'الغياب',
                rewards: 'المكافأت',
                settings: 'الإعدادات'
            },

            app: {
                welcome: 'مرحبا بك في لؤلؤة العصيمي ارشيف سيستم',
                copyright: 'جميع الحقوق محفوظة ©  ',
                gatetechs: 'بوابة التقنية',
                choose_bond_types: 'أختر نوع السند',
                choose_companies: 'أختر الشركة',
                choose_contracts: 'أختر العقد',
                choose_contracttypes: 'أختر نوع العقد',
                choose_employee: 'أختر الموظف',
                choose_license: 'أختر الرخصة',
                more_info:  'مزيد من المعلومات',
                bill_number: 'رقم الفاتورة',
                amount_duo: 'المبلغ المستحق',
                number_of_payments: 'عدد دفعات المبالغ',

                nationalities: 'الجنسيات',

                choose_notification_period: 'أختر فترة التنبيه',
                email_from : 'الإيميل لإرسال التنبيهات',
                email_to: 'الإيميل لإستقبال التنبيهات',

                bond_types: 'أنواع السندات المالية',
                companies: 'الشركات',
                contracts: 'العقود',
                check_number: 'رقم الشيك',
                bond_number: 'رقم السند',
                day: 'يوم',

                show_attachment : 'عرض الملف',
                add_new        : 'إضافة جديد',
                contact        : 'التواصل',
                all            : 'الكل',
                hello          : 'مرحباً ',
                profile        : 'حسابي',
                logout         : 'تسجيل خروج',
                purple         : 'بنفسجي',
                dark           : 'الأسود',
                update         : 'تعديل',
                create         : 'إنشاء',
                show           : 'إظهر',
                back           : 'رجوع',
                cancel         : 'إلغاء',
                active         : 'نشط',
                approved       : 'تم الموافقة',
                unapproved     : 'لم يتم الموافق',
                seen           : 'تم المشاهدة',
                unseen         : 'رسالة جديدة',
                inactive       : 'غير نشط',
                from           : 'من',
                to             : 'إلي',
                excel          : 'تنزيل ملف XLS',
                csv            : 'تنزيل ملف CSV',
                print          : 'طباعة الجدول',
                upload_excel   : 'رفع ملف XLSX',
                edit           : 'تعديل',
                analytics      : 'إحصائيات',
                addNew         : 'أضف جديد',
                dashboard      : 'لوحة التحكم',
                search         : 'بحث...',
                arabic         : 'عربي',
                english        : 'إنجليزي',

                all_rows       : 'الكل',
                showInHeader   : 'إظهر في أعلي الصفحة',
                showInFooter   : 'إظهر في أسفل الصفحة',
                showInSupport  : 'إظهر في قسم الدعم',

                start_cdate     : 'تاريخ التعاقد',
                end_cdate       : 'تاريخ الإنتهاء',
                start_date     : 'تاريخ البدأ',
                end_date       : 'تاريخ الإنتهاء',
                contract_start_date     : 'تاريخ بداية العقد',
                contract_end_date       : 'تاريخ إنتهاء العقد',
                notebookExpireDate : 'تاريخ إنتهاء صلاحية الدفتر',
                invoice_date   : 'تاريخ الفاتورة',
                bond_date      : 'تاريخ السند',
                date           : 'التاريخ',
                actions        : 'الإعدادات',
                status         : 'الحالة',
                sort           : 'الترتيب',
                rate           : 'التقييم',
                star           : 'نجمة',
                stars          : 'النجوم',
                upload         : 'أرفع الصورة',
                change_upload  : 'تعديل الصورة',
                
                upload_attachment : 'أرفع الملف',
                change_upload_attachment  :  'تعديل الملف',

                employeecategories: 'فئات الموظفين',
                jobtitles: 'المسمي الوظيفي',

                
                social         : 'التواصل الإجتماعي',
                facebook       : 'فيس بوك',
                twitter        : 'توتير',
                linkedin       : 'لينكد إن',

                export         : 'مدير الملفات',
                bulkActions    : 'جملة الإعدادات',

                // msgs
                success_title  : 'عمل رائع,',
                success_msg    : 'تم تنفيذ طلبك بنجاح',
                warning_title  : 'أنتظر من فضلك',
                warning_msg    : '',
                error_title    : 'خطأ',
                error_msg      : 'حدث خطأ من الخادم من فضلك حاول مرة آخري',
                no_data        : 'لا يوجد بيانات',
                invalid_credentials : 'البيانات غير صحيحة',

                month          : 'شهر',
                year           : 'سنة',

                january        : 'يناير',
                february       : 'فبراير',
                march          : 'مارس',
                april          : 'ابريل',
                may            : 'مايو',
                june           : 'يونيو',
                july           : 'يوليو',
                august         : 'أغسطس',
                september      : 'سبتمير',
                october        : 'أكتوبر',
                november       : 'نوفمبر',
                december       : 'ديسمبر',

                sunday         : 'الأحد',
                monday         : 'الأثنين',
                tuesday        : 'الثلاثاء',
                wedensday      : 'الأربع',
                thursday       : 'الخميس',
                friday         : 'الجمعة',
                saturaday      : 'السبت',

                absent         : 'غائب',
                reward         : 'مكافئة',
                vacation       : 'أجازة'

            },

            view: {
                attachemnts: 'المرفقات',
                bill_attachment : 'مرفقات الفاتورة',
                
                company_logo: 'لوجو الشركة',
                company_info: 'تفاصيل الشركة',
                company_name: 'أسم الشركة',
                company_body: 'وصف الشركة',
                company_address: 'عنوان الشركة',
                company_mobile: 'هاتف الشركة',
                company_email: 'البريد الإلكتروني',
                company_website: 'الموقع الإلكتروني',
                company_contact_person: 'مسؤول التواصل',

                contracttype_name: 'نوع العقد',
                contracttype_info: 'تفاصيل نوع العقد',
                contracttype_body: 'وصف نوع العقد',

                bill_image: 'صورة الفاتورة',
                bill_info: 'تفاصيل الفاتورة',
                bill_name: 'موضوع الفاتورة',
                bill_body: 'وصف الفاتورة',

                contract_name: 'موضوع العقد',
                contract_info: 'تفاصيل العقد',
                contract_body: 'وصف العقد / أعمال العقد',

                financialbondtype_name: 'اسم نوع السند',
                financialbondtype_info: 'تفاصيل نوع السند',
                financialbondtype_body: 'وصف نوع السند',

                financialbond_info: 'تفاصيل السند',
                financialbond_name: 'إلي السيد / السادة',
                financialbond_body: 'موضوع السند',
                financialbond_amount_in_letters: 'المبلغ بالحروف',
                bank_name: 'أسم البنك',

                reward_info: 'تفاصيل المكافئة',
                reward_name: 'موضوع المكافئة',
                reward_body: 'وصف / سبب المكافئة',

                absence_info: 'تفاصيل الغياب',
                absence_name: 'موضوع الغياب',
                absence_body: 'وصف / سبب الغياب',

                vacation_info: 'تفاصيل الأجازة',
                vacation_name: 'موضوع الأجازة',
                vacation_body: 'وصف / سبب الأجازة',

                companylicense_info: 'تفاصيل إدارة رخصة الشركات',
                companylicense_name: 'أسم الرخصة',
                companylicense_body: 'ملاحظات',

                license_startDate: 'تاريخ بدأ الرخصة',
                license_endDate: 'تاريخ إنتهاء الرخصة',
                license_no: 'رقم الرخصة',

                license_info: 'تفاصيل الرخصة',
                license_name: 'أسم الرخصة',
                license_body: 'وصف الرخصة',

                equipment_info: 'تفاصيل المعدات او السيارات',
                equipment_name: 'أسم المعدة / السيارة',
                equipment_body: 'وصف المعدة / السيارة',
                equipment_type: 'نوع المعدة / السيارة',
                equipment_model: 'موديل المعدة / السيارة',
                equipment_plateNo: 'رقم اللوحة',
                equipment_ownerName: 'أسم المالك',
                equipment_receiverName: 'أسم المستلم',

                employee_info: 'تفاصيل الموظف',
                employee_name: 'أسم الموظف',
                employee_image: 'صورة الموظف',
                employee_jobTitle : 'المسمي الوظيفي',
                employee_nationality: 'الجنسية',
                employee_civilNo: 'الرقم المدني',
                employee_passportNo: 'رقم جواز السفر',
                employee_passportExpireDate: 'تاريخ إنتهاء جواز السفر',
                employee_category: 'فئة الموظف',
                employee_fullName: 'أسم الموظف',
                employee_hiringDate: 'تاريخ التعيين',
                employee_residenceExpireDte: 'تاريخ إنتهاء الإقامة',
                employee_startWorkDate: 'تاريخ بدأ العمل',
                employee_endWorkDate: 'تاريخ إنتهاء اذن العمل',
                employee_phone: 'رقم الهاتف',
                employee_salary: 'إجمالي المرتب',
                employee_salaryPerDay: 'إجمالي راتب اليوم الواحد ( يخصم عند الغياب )',
                employee_bankName: 'اسم البنك',
                employee_bankIBAN: 'الرقم الدولي للبنك ( IBAN )',
                employee_bankBranchName: 'اسم الفرع',
                employee_bankCreditNo: 'رقم البطاقة ( Credit Card )',
                employee_bankPassword: 'رقم السري ( CVV )',
                employee_licenseNo: 'رقم رخصة السيارة',
                employee_licenseExpireDate: 'تاريخ إنتهاء الرخصة',

                setting_info: 'تفاصيل الإعدادات',


                username: 'أسم العضو',
                email: 'البريد الإلكتروني',
                image: 'الصورة',

                permissions: 'الصلاحيات',
                role_info: 'تفاصيل الصلاحية',

                role_name: 'أسم الصلاحية',
                password: 'كلمة المرور',
                users_no: 'عدد الأعضاء',
                contracts_no: 'عدد العقود',
                name: 'الأسم',
                title: 'العنوان',
                body: 'الوصف',
                addMore: 'أضف المزيد',
                noPermissionGranted: 'No permission granted',
            },

            role: {
                add            : 'إضافة',
                edit           : 'تعديل',
                delete         : 'حذف',
                view           : 'مشاهدة',
            },

            chart: {
                total_companies        : 'إجمالي الشركات',
                total_contracts        : 'إجمالي العقود',
                total_contract_types   : 'إجمالي أنواع العقود',
                total_bills            : 'إجمالي الفواتير',

                total_bond_types       : 'إجمالي أنواع السندات',
                total_financial_bonds  : 'إجمالي السندات المالية',

                total_auto_equipment   : 'إجمالي المعدات والسيارات', 
                total_licenses         : 'إجمالي الرخص', 
                total_company_licenses : 'إجمالي رخص الشركات',
                total_employees        : 'إجمالي الموظفين',

                total_notifications    : 'إجمالي التنبيهات',
                total_admins           : 'إجمالي مستخدمين النظام',

                total_roles            : 'إجمالي الصلاحيات',
                total_absences         : 'إجمالي الغياب',
                total_vacations        : 'إجمالي الأجازات',
                total_rewards          : 'إجمالي المكافئة',

                contracts_chart        : 'مخطط العقود',

                yearly                 : 'سنوي',
                quarter                : 'ربع',
                weekly                 : 'أسبوعي',
                monthly                : 'شهريا',
            },
            //
        },
    }
})